/**
 * PostHog custom event tracking — Shopify
 */
(function () {
    "use strict"; 
    // Util dasar
    function capture(name, props) {
      try {
        if (typeof posthog !== "undefined" && posthog && typeof posthog.capture === "function") {
          posthog.capture(name, props || {});
        }
      } catch (e) {}
    }
  
    function getThemeData() {
      return (window && window.phThemeData) || {};
    }
  
    var firedOnce = {};
    function once(key, fn) {
      if (!firedOnce[key]) {
        firedOnce[key] = true;
        fn();
      }
    }
  
    function toNumber(v) {
      var n = parseFloat(v);
      return isNaN(n) ? 0 : n;
    }
  
    // Key localStorage buat nandain "browser ini pernah di-identify sebagai
    // customer tertentu" — dipakai buat deteksi logout di page load berikutnya
    // (posthog nggak otomatis tau kalau visitor-nya udah logout).
    var IDENTIFIED_FLAG_KEY = "ph_identified_customer_id";

    function identifyCustomer() {
      var customer = getThemeData().customer;
      if (customer && customer.id) {
        var wasIdentifiedAs = null;
        try { wasIdentifiedAs = localStorage.getItem(IDENTIFIED_FLAG_KEY); } catch (e) {}
        once("identify_user", function () {
          try {
            if (typeof posthog !== "undefined" && posthog && typeof posthog.identify === "function") {
              posthog.identify(String(customer.id), {
                email: customer.email,
                name: customer.name
              });
              // Cuma fire user_logged_in pas transisi ke status login (browser
              // ini belum pernah di-identify sebagai customer ini) — bukan
              // tiap pageview selagi masih login.
              if (wasIdentifiedAs !== String(customer.id)) {
                capture("user_logged_in", {
                  customer_id: customer.id,
                  email: customer.email
                });
              }
              try { localStorage.setItem(IDENTIFIED_FLAG_KEY, String(customer.id)); } catch (e) {}
            }
          } catch (e) {}
        });
      } else {
        // Customer null di page ini. Kalau browser ini sebelumnya pernah
        // di-identify, berarti barusan logout — reset supaya distinct_id
        // baru dipakai dan nggak lanjut ke-atribusi ke akun lama.
        try {
          if (localStorage.getItem(IDENTIFIED_FLAG_KEY)) {
            localStorage.removeItem(IDENTIFIED_FLAG_KEY);
            if (typeof posthog !== "undefined" && posthog && typeof posthog.reset === "function") {
              posthog.reset();
            }
          }
        } catch (e) {}
      }
    }
  
    function firePageview() {
      once("pageview", function () {
        var data = getThemeData();
        var props = {
          path: window.location.pathname + window.location.search,
          referrer: document.referrer || "",
          page_type: data.pageType || "other"
        };
        if (data.pageType === "product" && data.product) {
          props.product_id = data.product.id;
          props.product_name = data.product.title;
          props.category = data.product.type;
          props.price = toNumber(data.product.price);
          props.currency = data.currency || "IDR";
        }
        capture("$pageview", props);
      });
    }
  
    // ---------------------------------------------------------------------
    // search_performed
    // ---------------------------------------------------------------------
  
    function fireSearch() {
      var data = getThemeData();
      if (data.pageType !== "search") return;
      once("search_performed", function () {
        var params = new URLSearchParams(window.location.search);
        capture("search_performed", {
          query: params.get("q") || "",
          results_count:
            typeof data.searchResultsCount === "number" ? data.searchResultsCount : null
        });
      });
    }
  
    // ---------------------------------------------------------------------
    // variant_selected
    // ---------------------------------------------------------------------
  
    function getSourceSection(form) {
      var section = form.closest("[data-section-type]");
      var type = section ? section.getAttribute("data-section-type") : "";
      if (type === "quick-view") return "quick_view";
      if (type === "featured-collection" || type === "best-sellers") return "best_sellers";
      if (getThemeData().pageType === "product") return "pdp";
      return "archive";
    }
  
    function getOptionName(btn) {
      var optionWrap = btn.closest(".pdp-option");
      var label = optionWrap ? optionWrap.querySelector(".pdp-option__label") : null;
      if (!label) return "";
      var clone = label.cloneNode(true);
      var selected = clone.querySelector(".pdp-option__selected");
      if (selected) selected.parentNode.removeChild(selected);
      return clone.textContent.replace(":", "").trim();
    }

    function getOptionValueLabel(btn) {
      var val = btn.getAttribute("data-opt-val") || "";
      if (btn.hasAttribute("data-label")) return btn.getAttribute("data-label");
      return val.indexOf("_") !== -1 ? val.split("_").slice(1).join("_") : val;
    }

    // variant picker: swatch/pill buttons (.pdp-swatch / .pdp-pill)
    function bindVariantSelect() {
      document.addEventListener("click", function (e) {
        var btn = e.target.closest(".pdp-swatch, .pdp-pill");
        if (!btn) return;
        var form = btn.closest("form");
        if (!form) return;
        var data = getThemeData();
        capture("variant_selected", {
          product_id: form.getAttribute("data-product-id") || (data.product && data.product.id) || "",
          product_name: form.getAttribute("data-product-title") || (data.product && data.product.title) || "",
          option_name: getOptionName(btn),
          variant_name: getOptionValueLabel(btn),
          source_section: getSourceSection(form)
        });
      });
    }
  
    // util add to cart
  
    var cartHandlers = [];

    function registerCartHandler(matchStr, onResponse) {
      cartHandlers.push({ match: matchStr, onResponse: onResponse });
    }
  
    function runHandlers(url, reqBody, resJson) {
      for (var i = 0; i < cartHandlers.length; i++) {
        if (url.indexOf(cartHandlers[i].match) !== -1) {
          try {
            cartHandlers[i].onResponse(reqBody, resJson, url);
          } catch (e) {}
        }
      }
    }
  
    function patchNetwork() {
      var origFetch = window.fetch;
      if (typeof origFetch === "function") {
        window.fetch = function (input, init) {
          var url = typeof input === "string" ? input : (input && input.url) || "";
          var reqBody = (init && init.body) || null;
          var result = origFetch.apply(window, arguments);
          result.then(function (res) {
            res
              .clone()
              .json()
              .then(function (json) {
                runHandlers(url, reqBody, json);
              })
              .catch(function () {});
          });
          return result;
        };
      }
  
      var XHR = window.XMLHttpRequest;
      var origOpen = XHR.prototype.open;
      var origSend = XHR.prototype.send;
      XHR.prototype.open = function (method, url) {
        this._phUrl = String(url || "");
        return origOpen.apply(this, arguments);
      };
      XHR.prototype.send = function (body) {
        var xhr = this;
        var url = xhr._phUrl || "";
        xhr.addEventListener("load", function () {
          try {
            var json = JSON.parse(xhr.responseText);
            runHandlers(url, body, json);
          } catch (e) {}
        });
        return origSend.apply(this, arguments);
      };
    }
  
    // ---- product_added_to_cart ----
    // Semua placement ATC (tombol PDP, popup varian, quick-add di product
    // card) sama-sama manggil fetch('/cart/add.js', ...) — jadi cukup satu
    // network hook (registerCartHandler di bawah) buat nangkep event-nya di
    // semua tempat. Listener klik generik di bawah ini cuma nyimpen KONTEKS
    // tombol yang diklik (biar source_section akurat), bukan trigger baru.
    var lastAtcSource = null;

    function resolveAtcSource(btn) {
      if (btn.hasAttribute("data-pdp-atc")) return "pdp";
      if (btn.hasAttribute("data-vp-atc")) return "variant_popup";
      if (btn.closest(".pdp-ymal")) return "you_may_also_like";
      if (btn.closest(".featured-products")) return "featured_products";
      var data = getThemeData();
      if (data.pageType === "search") return "search";
      if (data.pageType === "category") return "collection"; 
      return "archive";
    }

    function bindAtcSourceTracking() {
      document.addEventListener("click", function (e) {
        var btn = e.target.closest("[data-pdp-atc], [data-vp-atc], [data-atc-id]");
        if (!btn) return;
        lastAtcSource = resolveAtcSource(btn);
      });
    }

    function bindAddToCart() {
      registerCartHandler("/cart/add", function (reqBody, resJson) {
        var items = resJson && resJson.items ? resJson.items : resJson && resJson.id ? [resJson] : [];
        var source = lastAtcSource || (getThemeData().pageType === "product" ? "pdp" : "archive");
        items.forEach(function (item) {
          capture("product_added_to_cart", {
            product_id: item.product_id,
            product_name: item.product_title || item.title,
            category: item.product_type || "",
            variant: item.variant_title || "",
            price: toNumber(item.price) / 100,
            quantity: item.quantity,
            currency: getThemeData().currency || "IDR",
            page_type: getThemeData().pageType || "other",
            source_section: source
          });
        });
        lastAtcSource = null;
      });
    }

    // product_removed_from_cart — mekanisme sebenarnya di cart page ----
    function bindCartRemoveForm() {
      function captureRemoval(row) {
        var titleEl = row.querySelector(".cart-item__title");
        var variantEl = row.querySelector(".cart-item__variant");
        capture("product_removed_from_cart", {
          product_id: row.getAttribute("data-product-id") || "",
          variant_id: row.getAttribute("data-variant-id") || "",
          product_name: titleEl ? titleEl.textContent.trim() : "",
          variant: variantEl ? variantEl.textContent.replace("Shade:", "").trim() : "",
          price: toNumber(row.getAttribute("data-price")),
          quantity: parseInt(row.getAttribute("data-original-qty"), 10) || 1,
          currency: getThemeData().currency || "IDR",
          source_section: "cart"
        });
      }

      // Jalur 1: klik tombol minus sampai ke 0 (auto-submit lewat form.submit()).
      document.addEventListener(
        "click",
        function (e) {
          var minus = e.target.closest("[data-cart-qty-minus]");
          if (!minus) return;
          var row = minus.closest("[data-cart-item]");
          if (!row) return;
          var input = row.querySelector('input[name="updates[]"]');
          if (!input) return;
          var current = parseInt(input.value, 10) || 0;
          if (current !== 1) return; // cuma jadi 0 kalau sekarang persis 1
          captureRemoval(row);
        },
        true // capture phase — jalan sebelum handler klik cart.liquid sendiri
      );

      // Jalur 2: quantity diketik manual jadi 0, lalu submit form beneran
      // (tombol "Update cart" / "Checkout Now").
      document.addEventListener("submit", function (e) {
        var form = e.target;
        if (!form.classList || !form.classList.contains("cart-layout")) return;

        form.querySelectorAll("[data-cart-item]").forEach(function (row) {
          var input = row.querySelector('input[name="updates[]"]');
          if (!input) return;
          if (parseInt(input.value, 10) !== 0) return;
          captureRemoval(row);
        });
      });
    }
  
    // checkout_started — klik tombol checkout di halaman cart
    function bindCheckoutStarted() {
      document.addEventListener("click", function (e) {
        var el = e.target.closest(
          'a[href="/checkout"], a[href^="/checkout?"], button[name="checkout"], input[name="checkout"]'
        );
        if (!el) return;
        var data = getThemeData();
        if (data.pageType !== "cart") return;
        capture("checkout_started", {
          cart_total: data.cart ? data.cart.total_price : null,
          item_count: data.cart ? data.cart.item_count : null,
          currency: data.currency || "IDR"
        });
      });
    }
  
    // whatsapp_clicked — #floating-whatsapp-button
    function bindWhatsappClick() {
      document.addEventListener("click", function (e) {
        var el = e.target.closest("#floating-whatsapp-button");
        if (!el) return;
        var data = getThemeData();
        capture("whatsapp_clicked", {
          page: window.location.pathname,
          page_type: data.pageType || "other"
        });
      });
    }

    // banner_clicked 

    function bindBannerClick() {
      document.addEventListener("click", function (e) {
        var container = e.target.closest(".hero-slider__slide, .cc-card");
        if (!container) return;
        var media = container.querySelector("[data-banner-name], [data-banner-category]");
        if (!media) return;
        var link = container.closest("a") || container.querySelector("a");
        var data = getThemeData();
        capture("banner_clicked", {
          banner_name: media.getAttribute("data-banner-name") || "",
          banner_category: media.getAttribute("data-banner-category") || "",
          link_url: link ? link.getAttribute("href") : "",
          page: window.location.pathname,
          page_type: data.pageType || "other"
        });
      });
    }

    // social_link_clicked
    function bindSocialLinkClick() {
      document.addEventListener("click", function (e) {
        var link = e.target.closest(".footer-social__link");
        if (!link) return;
        var data = getThemeData();
        capture("social_link_clicked", {
          platform: link.getAttribute("aria-label") || "",
          link_url: link.getAttribute("href") || "",
          page: window.location.pathname,
          page_type: data.pageType || "other"
        });
      });
    }

    // ---------------------------------------------------------------------
    // Event custom general, Contoh implementasi:
    //      <a href="..." data-ph-event="custom_event_name"
    //         data-ph-props='{"page":"product"}'>Klik</a>
  
    function bindCustomDataEvents() {
      document.addEventListener("click", function (e) {
        var el = e.target.closest("[data-ph-event]");
        if (!el) return;
        var name = el.getAttribute("data-ph-event");
        var propsAttr = el.getAttribute("data-ph-props");
        var props = {};
        if (propsAttr) {
          try {
            props = JSON.parse(propsAttr);
          } catch (e) {}
        }
        props.page = window.location.pathname;
        capture(name, props);
      });
    }
  
    // ---------------------------------------------------------------------
    // Bootstrap
    // ---------------------------------------------------------------------
  
    function init() {
      patchNetwork();
      identifyCustomer();
      firePageview();
      fireSearch();
      bindVariantSelect();
      bindAtcSourceTracking();
      bindAddToCart();
      bindCartRemoveForm();
      bindCheckoutStarted();
      bindWhatsappClick();
      bindBannerClick();
      bindSocialLinkClick();
      bindCustomDataEvents();
    }
  
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", init);
    } else {
      init();
    }
  })();